import React from "react";
import { withRouter } from "react-router-dom";
import ReduxToastr from "react-redux-toastr";
import { Helmet } from "react-helmet";

import Routes from "./routes/Routes";

import "../styles/common.scss";
import { useAppSettings } from "../core/hooks/useAppSettings";
import api from "../api";
import SessionTimeOut from "./session-timeout";
import { useAuth } from "../core";

const App: React.SFC = () => {
  useAppSettings(api.settings);
  const auth = useAuth(api.auth);
  return (
    <div>
      <Helmet htmlAttributes={{ lang: "en", dir: "ltr" }}>
        <meta charSet="utf-8" />
        <title>Cityinfo</title>
      </Helmet>
      <ReduxToastr
        timeOut={4000}
        newestOnTop={false}
        preventDuplicates
        position="top-center"
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        progressBar={false}
      />
      <Routes />
      {auth.isAuthenticated &&
        <>
          <SessionTimeOut />
        </>
      }
    </div>
  );
};

// without using withRouter, route changes only reflect in url but not on page.
export default withRouter(App);
